import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';

import Registry from 'registry';

import {t} from 'l10n'

import '../../sass/profile/wishlistProfile.scss';
import paths from 'paths';

class ProfileWishlistBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render(){
        let BOBSTORE_URL = Registry.get('BOBSTORE_URL');

        let {wishlist, user, sectionNumber} = this.props,
            {list, totalCount} = wishlist;

        return (
            <aside className={'wishlist-main ' + ((sectionNumber % 2)==0?'even':'odd')}>
                <div className="content">
                    <div className="heading">
                        <h2>{t('Wishes on')} <a href={BOBSTORE_URL} target="_blank">Bobstore</a> <em>{totalCount}</em></h2>
                        <span>{t('The gifts will be delivered to %1 by Bob in 3 days max!', user.nick)}</span>
                    </div>
                    <div className="list-wishlist-main ui-responsive-grid single-row">
                        {list.map((item, index) =>
                            <div key={index}>
                                <div className="list-wishlist-main-item">
                                    <div className="img">
                                        <a href={item.buy_as_gift_url} target="_blank" className="basket"></a>
                                        <img src={item.thumbnail_url} alt=""/>
                                    </div>
                                    <div className="text">
                                        <p className="name-wishlist">
                                            {item.title}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {list.length ? <Link to={paths.profileWishlist.toPath({nick: user.nick})} className="get-all-wishlist">{t('View full wishlist')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

export default ProfileWishlistBlock;


// WEBPACK FOOTER //
// ./src/components/profile/ProfileWishlistBlock.js